import { create } from 'zustand'
import Cookies from 'js-cookie'

export const useSearchPropStore = create((set) => ({
    searchData: {
        "SortOrder": "DESC",
        "SortBy": "RegisterDate",
        "SearchType": "Sale",
        // "Offset": 0,
        "Limit": 10,
        // "Count": "",
        "MaxSalePrice": "",
        "MinSalePrice": "",
        "MaxPreSalePrice": "",
        "MinPreSalePrice": "",
        "MaxRentPrice": "",
        "MinRentPrice": "",
        "MaxMortgagePrice": "",
        "MinMortgagePrice": "",
        "MaxInfrastructure": "",
        "MinInfrastructure": "",
        "MaxPropertyAgeYear": "",
        "MinPropertyAgeYear": "",
        "MaxRoomsCount": "",
        "MinRoomsCount": "",
        "MaxSpace": "",
        "MinSpace": "",
        "MaxCommercialMeter": "",
        "MinCommercialMeter": "",
        "MinRegisterDate": "",
        "MaxRegisterDate": "",
        "MaxStoreyCount": "",
        "MinBrinkValue": "",
        "MinStreetSpace": "",
        "StoreyNo": "",
        "LandLord": "",
        "PropertyTypes": "",
        "UsageTypes": "",
        "Areas": [],
        "SearchKeys": "",
        "RentPrefer": "",
        "EstateStatus": "",
        "Directions": "",
        "CertificateTypes": "",
        "Aggregations": "",
        "Dongs": "",
        "Tags": "",
        "Facilities": "",
        "PropertyAge": "",
        "AgencyId": [Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id],
        "InputSeparate": "",
        "Store": "",
        "Elevator": "",
        "Parking": "",
        "Elec3Phase": "",
        "Court": "",
        "IsNotImpasse": "",
        "MustHaveLoan": "",
        "ShortTermRent": "",
        "OwnerShouldNotResident": "",
        "HasPicture": "",
        "IsArchived": "",
        "FromDivar": "",
        // "NotDivarTokens": "",
        "IsBought": "",
        "NotIsBought": "",
        "LocationId": Cookies.get('locationId') && Cookies.get('locationId'),
        "Ids": "",
        "Row": "",
        "AgencyInfo": true,
        "LandLordInfo": true,
        "WithSubAgencyProperties": 1,
        "Users" : []
    },
    setSearchData: (newData) => set((state) => {
        return { ...state, searchData: { ...state.searchData, [newData.name]: newData.value } }
    },
    ),
    emptySearchData: () => set((state) => {
        const tmp = { ...state.searchData }
        for (const i in tmp) {
            if (i == "Limit")
                tmp[i] = 10
            else if (i == "LocationId")
                tmp[i] = Cookies.get('locationId') ? Cookies.get('locationId') : ''
            else if (i == "AgencyId")
                tmp[i] = Cookies.get('agency') ? JSON.parse(Cookies.get('agency')).Id : ''
            else if (i == "SearchType")
                tmp[i] = "Sale"
            else if (i == "Areas")
                tmp[i] = []
            else
                tmp[i] = ""
        }
        return { ...state, searchData: tmp }
    }),
    propertySelected: "",
    setPropertySelected: (newData) => set((state) => {
        console.log("propertySelected new", newData)
        return { ...state, propertySelected: newData }
    }),
}))